import { withQuestionnaireFuncs } from 'Context/WithQuestionnaireAnswer';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Decorator from 'Components/UI/BehavioralFormElement/LabelDecorator/Floating';
import Input from 'Components/UI/BehavioralFormElement/NormalizedInput/Numeric';
import { withHousehold } from 'Context/HouseholdContext';
import { noop } from 'Helpers/PropTypes';
import { ContextIndex } from './FieldList';
import { makeHideable } from '../Hideable';

import './index.css';
import withViewContext from './withViewContext';

class NumericString extends Component {
  constructor(props) {
    super(props);

    const {
      apiResponse: {
        attributes: { value, isReadonly },
      },
    } = props;
    this.state = {
      value,
      isReadonly: isReadonly === 'true',
      isDone: false,
    };

    this.onChange = this.onChange.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  componentDidMount() {
    const {
      householdId,
      answerKey,
      getQuestionnaireAnswer,
      getIndexedQuestionnaireAnswer,
    } = this.props;
    const index = this.context;

    let promise;
    if (index > -1) {
      promise = getIndexedQuestionnaireAnswer(householdId, answerKey, index);
    } else {
      promise = getQuestionnaireAnswer(householdId, answerKey);
    }

    return promise
      .then((res) => this.setState({ value: res.attributes.value, isReadonly: res.attributes.isReadonly === 'true' }))
      .finally(() => this.setState({ isDone: true }));
  }

  onChange(name, value) {
    this.setState({ value });
  }

  onBlur() {
    const {
      householdId,
      uploadValue,
      answerKey,
      validation,
      onChange,
      name,
    } = this.props;
    const { value } = this.state;
    if (validation(value)) {
      const index = this.context;
      uploadValue(householdId, answerKey, {
        attributes: {
          value,
          index,
        },
      });
      onChange(name, value);
    }
  }

  render() {
    const {
      onBlur,
      onChange,
      props: { format, name, placeholder },
      state: { value, isReadonly, isDone },
    } = this;

    if (!isDone) {
      return null;
    }

    return (
      <div className="questionnaire-input">
        <Decorator label={placeholder}>
          <Input
            disabled={isReadonly}
            value={value}
            format={format}
            onBlur={onBlur}
            onChange={onChange}
            name={name}
            placeholder={placeholder}
          />
        </Decorator>
      </div>
    );
  }
}

NumericString.propTypes = {
  format: PropTypes.string,
  name: PropTypes.string.isRequired,
  uploadValue: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  answerKey: PropTypes.string.isRequired,
  householdId: PropTypes.number.isRequired,
  apiResponse: PropTypes.instanceOf(Object),
  validation: PropTypes.func,
  onChange: PropTypes.func,
  getQuestionnaireAnswer: PropTypes.func.isRequired,
  getIndexedQuestionnaireAnswer: PropTypes.func.isRequired,
};

NumericString.defaultProps = {
  format: undefined,
  validation: () => true,
  apiResponse: { attributes: {} },
  onChange: noop,
};

NumericString.contextType = ContextIndex;

const NumericStringInput = withHousehold(withQuestionnaireFuncs(withViewContext(NumericString)));

export default makeHideable(NumericStringInput);
